"use strict";
var config = {
  instrument: false
};

function configure(name, value) {
  if (arguments.length === 2) {
    config[name] = value;
  } else {
    return config[name];
  }
}

exports.config = config;
exports.configure = configure;


//////////////////
// WEBPACK FOOTER
// ./~/es6-promise/dist/commonjs/promise/config.js
// module id = 176
// module chunks = 0